import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { SectionLabel } from "@/components/FormField";

const initials = (name) => name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export const Leadership = ({ profile }) => (
  <section id="leadership" data-testid="leadership-team-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 sm:pb-28">
    <SectionLabel>leadership</SectionLabel>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl uppercase tracking-wide mt-3">Who runs the fleet</h2>
    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {profile.owners.map((o, i) => (
        <article key={i} data-testid={`owner-card-${i}`} className="border border-slate-800 bg-[#0A0F1C]/90 p-6 relative hud-corner hover:border-cyan-500/40 transition-colors">
          <div className="flex items-center gap-4">
            <span className="grid place-items-center w-14 h-14 border glow-magenta font-display text-lg text-[#FF007F]">{initials(o.name)}</span>
            <div>
              <h3 className="font-display text-sm uppercase tracking-widest text-slate-100">{o.name}</h3>
              <p className="font-mono text-xs text-cyan-400 mt-1">{o.title}</p>
            </div>
          </div>
          {o.bio && <p className="mt-5 text-sm text-slate-400 leading-relaxed">{o.bio}</p>}
        </article>
      ))}
    </div>
  </section>
);

export const SiteFooter = ({ profile }) => (
  <footer className="border-t border-cyan-500/20 bg-[#02050C]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-8 text-sm">
      <div>
        <p className="font-display uppercase tracking-widest">{profile.company_name}</p>
        <p className="text-slate-500 mt-2">{profile.tagline}</p>
      </div>
      <ul className="space-y-2 font-mono text-slate-300" data-testid="footer-contact">
        {profile.phone && <li className="flex gap-2"><Phone className="w-4 h-4 text-[#00FF66]" />{profile.phone}</li>}
        {profile.email && <li className="flex gap-2"><Mail className="w-4 h-4 text-cyan-400" />{profile.email}</li>}
        {profile.hq_address && <li className="flex gap-2"><MapPin className="w-4 h-4 text-[#FF007F]" />{profile.hq_address}</li>}
      </ul>
      <div className="md:text-right space-y-2">
        <Link to="/login" className="block font-mono text-xs uppercase tracking-wider text-cyan-300 hover:text-white" data-testid="footer-customer-login-link">Customer sign in</Link>
        <Link to="/staff/login" className="block font-mono text-xs uppercase tracking-wider text-slate-500 hover:text-white" data-testid="staff-login-button">Staff access</Link>
      </div>
    </div>
  </footer>
);
